export default __webpack_public_path__ + "static/media/marker.55264990.svg";